import CryptoJS from "crypto-js";

export function clearUmamiSession() {
  const domains = [
    window.location.hostname,
    "." + window.location.hostname
  ];

  domains.forEach(domain => {
    document.cookie = `umami_session=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  });

  document.cookie = "umami_session=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
}

export function trackEvent(name, data = {}) {
  if (window.umami) {
    window.umami.track(name, data);
  }
}

// Fungsi untuk memformat tanggal
export function formatDate(date) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString(undefined, options);
}

// Fungsi untuk memformat nomor
export function formatNumber(number) {
    return new Intl.NumberFormat().format(number);
}


export function decryptionData(data) {
    const encript = localStorage.getItem('encript');
    const status = typeof encript !== undefined ? encript : '';
    if(status == 1){
        let secretKey = process.env.VUE_APP_SCRET_KEY;
        const bytes = CryptoJS.AES.decrypt(data, secretKey);
        const decryptedDataString = bytes.toString(CryptoJS.enc.Utf8);
        const convert = JSON.parse(decryptedDataString);
        return convert;
    }else{
        const convert = data;
        return convert;
    }
}

export function datetimenow() {
    const date = new Date();
    // Format date
    const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = date.toLocaleDateString('id-ID', dateOptions);

    // Format time
    const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
    const formattedTime = date.toLocaleTimeString('id-ID', timeOptions);

    console.log(formattedDate); // Output: "2 November 2024"
    console.log(formattedTime); // Output: "14:30:00" (or current time)
return formattedDate+' '+formattedTime;
}

export function datemonth(datetime) {
    // Tanggal dalam format ISO
    const isoDate = datetime;//format 2024-11-08T12:34:56.789Z

    // Buat objek Date dari string ISO
    const date = new Date(isoDate);

    // Buat array nama bulan
    const months = [
    "Januari", "Februari", "Maret", "April", "Mei", "Juni",
    "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ];

    // Dapatkan hari, bulan, dan tahun
    const day = date.getDate() ; // Menambahkan 1 hari untuk mendapatkan 9 November
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Format akhir
    const formattedDate = `${day} ${month} ${year}`;

    return formattedDate;



}
export function timedate(datetime) {
    const isoDate = datetime;
    const date = new Date(isoDate);
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const formattedDateTime = `${hours}:${minutes}`;
    return formattedDateTime;
}

export function generateFilterDate(type) {
  const today = new Date();
  let start_date = "";
  let end_date = "";

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  if (type === 'TODAY') {
    start_date = formatDate(today);
    end_date = formatDate(today);
  }

  if (type === 'FROM_YESTERDAY') {
    const endDate = new Date(today);
    const startDate = new Date(today);
    startDate.setDate(startDate.getDate() - 1);
    start_date = formatDate(startDate);
    end_date = formatDate(endDate);
  }

  if (type === 'THIS_WEEK') {
    const startDate = new Date(today);
    const day = startDate.getDay();
    const diff = startDate.getDate() - (day === 0 ? 6 : day - 1);
    startDate.setDate(diff);
    start_date = formatDate(startDate);
    end_date = formatDate(today);
  }

  if (type === 'PREVIOUS_WEEK') {
    const currentDay = today.getDay();

    const endOfWeek = new Date(today);
    const daysUntilSunday = currentDay === 0 ? 0 : 7 - currentDay;
    endOfWeek.setDate(endOfWeek.getDate() + daysUntilSunday);

    const startDate = new Date(endOfWeek);
    startDate.setDate(startDate.getDate() - 13);

    start_date = formatDate(startDate);
    end_date = formatDate(today);
  }

  if (type === 'THIS_MONTH') {
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    start_date = formatDate(startDate);
    end_date = formatDate(today);
  }

  if (type === 'PREVIOUS_MONTH') {
    const startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const endDate = new Date(today.getFullYear(), today.getMonth(), 0);
    start_date = formatDate(startDate);
    end_date = formatDate(endDate);
  }

  return { start_date, end_date, type };
}

export function formatBytes(bytes) {
     bytes = Number(bytes);
    


  if (!bytes || isNaN(bytes)) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = bytes / Math.pow(k, i);

//   return `${(value.toFixed(decimals))} ${sizes[i]}`;

  return `${Math.round(value)} ${sizes[i]}`;
}
export function toMB(bytes) {
     bytes = Number(bytes);
  return (bytes / (1024 * 1024)).toFixed() ;
}

export function formatBytesAuto(bytes, decimals = 1) {
     bytes = Number(bytes);
  if (!bytes || isNaN(bytes)) return '0 B';

  const kb = 1024;
  const mb = kb * 1024;
  const gb = mb * 1024;

// console.log('bytes')
// console.log(bytes)
  if (bytes >= gb) {
    return (bytes / gb).toFixed(decimals) + ' GB';
  } else if (bytes >= mb) {
    return (bytes / mb).toFixed(decimals) + ' MB';
  } else if (bytes >= kb) {
    return (bytes / kb).toFixed(decimals) + ' KB';
  } else {
    // byte kecil
    return bytes + ' B';
  }
}
export function bytesToMBNominal(bytes) {
  bytes = Number(bytes);
  if (!bytes || isNaN(bytes)) return 0;

  const mb = 1024 * 1024;
  return Math.round(bytes / mb);
}
export function formatMBtoGB(mB, decimals = 1) {
  mB = Number(mB);
  if (!mB || isNaN(mB)) return '0 GB';

  return (mB / 1024).toFixed(decimals) + ' GB';
}



// export function formatScrapeDuration(durationSeconds, decimals = 2) {
//   if (durationSeconds < 1) {
//     // Kalau kurang dari 1 detik, tampilkan dalam ms
//     const ms = durationSeconds * 1000;
//     return `${ms.toFixed(decimals)} ms`;
//   } else {
//     // Kalau 1 detik ke atas, tampilkan detik dengan decimal
//     return `${durationSeconds.toFixed(decimals)} s`;
//   }
// }
export function formatScrapeDuration(durationSeconds, decimals = 2) {
  // Validasi input bukan angka atau negatif

  if (typeof durationSeconds !== 'number' || isNaN(durationSeconds) || durationSeconds < 0) {
      alert(durationSeconds)
    return '-';
  }

  if (durationSeconds < 1) {
    // Kalau kurang dari 1 detik, tampilkan dalam ms
    const ms = durationSeconds * 1000;
    return `${ms.toFixed(decimals)} ms`;
  } else {
    // Kalau 1 detik ke atas, tampilkan detik dengan decimal
    return `${durationSeconds.toFixed(decimals)} s`;
  }
}

export function processTopicKeywords(data, collections, topicKeywordList) {
  const collectionFlags = {
    NEWS_FLAG: 0,
    TWITTER_FLAG: 0,
    YTB_FLAG: 0,
    TIKTOK_FLAG: 0,
    INSTAGRAM_FLAG: 0
  };

  const collectionNameToFlag = {
    'mediaonline': 'NEWS_FLAG',
    'twitter': 'TWITTER_FLAG',
    'youtube': 'YTB_FLAG',
    'tiktok': 'TIKTOK_FLAG',
    'instagram': 'INSTAGRAM_FLAG'
  };

  for (const collection of collections) {
    if (collection.STATUS == 1) {
      const flagName = collectionNameToFlag[collection.NAME_COLLECTION];
      if (flagName) {
        collectionFlags[flagName] = 1;
      }
    }
  }

  const completedTopicData = JSON.parse(JSON.stringify(data));

  for (let i = 0; i < completedTopicData.length; i++) {
    const topicItem = completedTopicData[i];

    const matchingTopic = topicKeywordList.find(
      topic => topic.SEQ_ID == topicItem.SEQ_ID
    );

    if (matchingTopic && matchingTopic.KEYWORD_ARR) {
      const existingKeywords = new Set();
      for (const kw of topicItem.KEYWORD) {
        existingKeywords.add(kw.KEYWORD.toLowerCase().trim());
      }

      const topicKeywords = matchingTopic.KEYWORD_ARR
        .split(', ')
        .map(k => k.trim())
        .filter(k => k.length > 0);

      const additionalKeywords = topicKeywords.filter(
        keyword => !existingKeywords.has(keyword.toLowerCase().trim())
      );

      for (const additionalKeyword of additionalKeywords) {
        const newKeywordObj = {
          SEQ_ID: "",
          GROUP_ID: topicItem.SEQ_ID,
          KEYWORD: additionalKeyword,
          KEYWORD_LANG: "ID",
          KEYWORD_STATUS: 1,
          NEWS_FLAG: collectionFlags.NEWS_FLAG,
          TWITTER_FLAG: collectionFlags.TWITTER_FLAG,
          YTB_FLAG: collectionFlags.YTB_FLAG,
          TIKTOK_FLAG: collectionFlags.TIKTOK_FLAG,
          INSTAGRAM_FLAG: collectionFlags.INSTAGRAM_FLAG,
          KEYWORD_ID_MD5: "",
          SYS_CREATED_DATE: "",
          SYS_CREATED_BY: "",
          SYS_UPDATED_DATE: "",
          SYS_UPDATED_BY: ""
        };

        topicItem.KEYWORD.push(newKeywordObj);
      }
    }
  }

  return completedTopicData;
}

export const encodeKeywordRequest = (selectedKeywords, topicKeywordSentiment) => {
  if (selectedKeywords == "All" || selectedKeywords == "" || !selectedKeywords) {
    const allKeywords = topicKeywordSentiment.slice(1);
    return allKeywords
      .map(k => encodeURIComponent(k.value ?? k).replace(/%2C/gi, '%252C'))
      .join(",");
  }

  const keywords = Array.isArray(selectedKeywords)
    ? selectedKeywords
    : [selectedKeywords];

  return keywords
    .map(k => k
      .replace(/&/g, '%26')
      .replace(/\+/g, '%2B')
      .replace(/,/g, '%252C'))
    .join(",");
};